/**
 * @generated SignedSource<<59c688034c514004ec7b98115b4c488f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSendToFriendModalLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AuthShareModal_viewer">;
  readonly " $fragmentType": "PdpSharedSendToFriendModalLazy_viewer";
};
export type PdpSharedSendToFriendModalLazy_viewer$key = {
  readonly " $data"?: PdpSharedSendToFriendModalLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSendToFriendModalLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSendToFriendModalLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuthShareModal_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7680aaf2b52f43693fd300127ebf3017";

export default node;
